import React, {Component} from "react"
import {Button, Checkbox, Form, Radio, Input} from "semantic-ui-react"
import _ from "lodash"
import DatePicker from "react-datepicker"
import 'react-datepicker/dist/react-datepicker.css';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from "moment"
import {Trans} from 'react-i18next'

const parser        = {}
parser.default = ({field}) => {
    console.error(`Could not find a parser for ${field.type}`)
    return <div className="pa3 text-center f6">
      <div>Feld-Typ {field.type} wird noch nicht unterstützt.</div>
    </div>

}
parser.eEnumeration = ({key, field, onChange}) => <Choices key={key} field={field} onChange={onChange}/>

parser.eNumeric = ({key, field, onChange}) => <StepInput key={key} field={field} onChange={onChange}/>
parser.eChoice  = ({key, field, onChange}) => <ChoiceInput key={key} field={field} onChange={onChange}/>

const inputFormat = "MM/DD/YYYY"
parser.eDate      = ({field, onChange}) => {
  let currentDate = moment(field.result, inputFormat)
  if (!currentDate.isValid()) currentDate = moment()
  return (
    <Form.Group key={currentDate}>
      <Form.Field>
        <label>{field.name}</label>
        <DatePicker
          inline
          dateFormat="DD.MM.YYYY"
          isClearable={true}
          selected={currentDate}
          onChange={(time) => {
            if (!time || !time.isValid()) {
              field.result = ""
              return
            }
            field.result = time.format(inputFormat)
            onChange(field)
          }}
        />
        <br/>
        {/*<pre className="black-80">{field.result}</pre>*/}
      </Form.Field>
      {/*<pre>{JSON.stringify(field, null, 2)}</pre>*/}
    </Form.Group>
  )
}

parser.eTime = ({field, onChange, key}) => {
  let currentDate = moment(field.result, "HH:mm")
  if (!currentDate.isValid()) currentDate = moment()
  return (
    <Form.Group key={key}>
      <Form.Field>
        <label>{field.name}</label>
        <TimePicker showSecond={false}
                    value={currentDate}
                    onChange={(time) => {
                      if (!time || !time.isValid()) {
                        field.result = ""
                        return
                      }
                      field.result = time.format("HH:mm")
                      // console.log("field::change", field.result)
                      _LTracker.push({ message: "EXTERNALTECHNICIAN: field::change " + field.result , level: "INFO" });
                      onChange(field)
                    }}
                    allowEmpty
        />
      </Form.Field>
      {/*<pre className="black-80">{JSON.stringify(field, null, 2)}</pre>*/}
    </Form.Group>
  )
}


const Fields = ({step, onChange}) => {
  let fields = null
  if (step.fields) {
    fields = _.map(step.fields, (field, key) => {
      const fieldComponent = parser[field.type] || parser.default
      return fieldComponent({field, onChange, key})
    })
  }
  return <div>{fields}</div>
}

export {Fields}


class MultipleChoice extends Component {
  constructor({field, config}) {
    super()
    this.state = {}
    if (!field.result) field.result = ""

    let value = field.result.split(";")

    this.state = {
      field, config, value
    }
  }

  componentWillReceiveProps({field, config}) {
    this.setState({field, config})
  }

  handleChange = (e, {value}) => {
    this.setState({value})
    this.props.onChange(e, {value})
    setValue(this.state.field, value)
  }

  render() {
    let { value, config} = this.state
    let formFields             = _.map(config.Enumeration.value, (choice, key) => {
      return (
        <Form.Field key={key}>
          <Checkbox
            onChange={(e, {checked}) => {
              let value
              if (checked) value = _.union(this.state.value, [String(key)])
              if (!checked) value = _.without(this.state.value, String(key))
              this.handleChange(e, {value})
            }}
            checked={_.includes(value, String(key))}
            label={choice}/>
        </Form.Field>
      )
    })

    return (
      <div>
        {formFields}
      </div>
    )
  }
}

class SingleChoice extends Component {
  constructor({field, config}) {
    super()
    this.state = {}
    let value  = String(field.result)
    this.state = {
      field, config, value
    }
  }

  componentWillReceiveProps({field, config}) {
    this.setState({field, config})
  }

  handleChange = (e, {value}) => {
    this.setState({value})
    this.props.onChange(e, {value})
    setValue(this.state.field, value)
  }

  render() {
    let {config}   = this.state
    let formFields = _.map(config.Enumeration.value, (choice, key) => {
      return (
        <Form.Field key={key}>
          <Radio
            label={choice}
            name='radioGroup'
            value={String(key)}
            checked={this.state.value === String(key)}
            onChange={this.handleChange}
          />
        </Form.Field>
      )
    })

    return (<div>{formFields}</div>)
  }
}

class StepInput extends Component {
  constructor({field}) {
    super()
    this.state = {}
    let value  = field.result || ""

    this.state = {
      field, value
    }
  }

  componentWillReceiveProps({field}) {
    this.setState({field})
  }

  handleChange = (e, {value}) => {
    setValue(this.state.field, value)
    this.setState({value})
    this.props.onChange()
  }

  render() {
    let {field}      = this.state
    let {value}      = this.state
    let labelContent = ""
    if (field.config.unit) {
      labelContent = field.config.unit.value
    }
    return (
      <Form.Field>
        <label>{field.name}</label>
        <Input
          label={{basic: true, content: labelContent}}
          labelPosition='right'
          onChange={this.handleChange}
          value={value}/>
      </Form.Field>
    )
  }
}

class ChoiceInput extends Component {
  constructor({field}) {
    super()
    this.state = {}
    let value  = field.result
    this.state = {
      field, value
    }
  }

  handleChange = (e, {value}) => {
    setValue(this.state.field, value)
    this.setState({value})
    this.props.onChange()
  }

  render() {
    let {field}  = this.state
    let {value}  = this.state
    let {config} = field
    // default Enumeration
    if( !config.Enumeration  ){
      config.Enumeration = defaultEnumeration
    }
    if (!config.Enumeration) return null
    let buttons = config.Enumeration.value.map((choice, key) => {
      let color = null
      if (value === key) color = "green"
      return <Button className="btn-block" key={key} type="button"
                     onClick={(e) => {
                       this.handleChange(e, {value: key})
                     }} color={color}>{choice}</Button>
    })
    return (
      <Form.Field>
        <label>{field.name}</label>
        <div className="btn-group stacked">
          {buttons}
        </div>
      </Form.Field>
    )
  }
}

class Choices extends Component {
  constructor({field}) {
    super()
    let config = getChoiceConfig({field})
    this.state = {
      field, config
    }
  }

  componentWillReceiveProps({field}) {
    let config = getChoiceConfig({field})
    this.setState({field, config})
  }

  handleChange = (e, {value}) => {
    setValue(this.state.field, value)
    this.setState({value})
    this.props.onChange(e, {value})
  }

  render() {
    let {config} = this.state
    let {field}  = this.state
    let choicetype = "singlechoice"
    if (config.choicetype) {
      choicetype = config.choicetype.value
    }
    switch (true) {
      case choicetype === "multiplechoice":
        return <MultipleChoice config={config} field={field}
                               onChange={this.handleChange}/>
      case choicetype === "singlechoice":
        return <SingleChoice config={config} field={field}
                             onChange={this.handleChange}/>
      default:
        console.error(`Could not find a visualization for choicetype ${config.choicetype}`)
    }
  }
}

export {parser}

const setValue = (field, value) => {
  if (Array.isArray(value)) {
    value = value.join(";")
  }
  field.result = value
  field.setResult(value)
  return field
}

const getChoiceConfig = ({field}) => {
  return field.config
}

let enumerationDone = <Trans i18nKey="enumeration.done">Erledigt</Trans>;
let enumerationRework = <Trans i18nKey="enumeration.rework">Nacharbeit erforderlich</Trans>;

const defaultEnumeration = {
  id: 0,
  type: "enumeration",
  value: [
    enumerationDone, enumerationRework
  ]
}



// WEBPACK FOOTER //
// ./src/pages/components/Step/Field.js